import { RuntimeBaseError } from "@/domains/errors/kinds/RuntimeBaseError";

export class RuntimeParseError extends RuntimeBaseError {}
